import { FC } from 'react';
// components
import AddBaseCoatingForm from 'components/main/BaseCoating/Edit';

const AddBaseCoating: FC = () => <AddBaseCoatingForm />;

export default AddBaseCoating;
